import React from 'react';

const FacebookSocialsIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 7.0426C14 3.15213 10.8669 0 7 0C3.13306 0 0 3.15213 0 7.0426C0 10.5576 2.5598 13.4712 5.90625 14V9.07842H4.12802V7.0426H5.90625V5.49095C5.90625 3.72604 6.9506 2.75116 8.55016 2.75116C9.31621 2.75116 10.1173 2.8886 10.1173 2.8886V4.62085H9.23435C8.365 4.62085 8.09375 5.16381 8.09375 5.72069V7.0426H10.0351L9.72464 9.07842H8.09375V14C11.4402 13.4712 14 10.5576 14 7.0426Z" fill="currentColor" />
  </svg>
);

export default FacebookSocialsIcon;
